import Checkbox from "../../../../components/Checkbox/Checkbox"
import { AnalysisControlsProps } from "./AnalysisControls.types"
import "./AnalysisControls.css"

const AnalysisControls = (props: AnalysisControlsProps) => {

  const { 
    overlayCheckbox,
    showMaxCheckbox,
    showMinCheckbox,
    version
   } = props

  return (
    <>
      <h2 className="analysis-control-title">Analysis</h2>

      {/* <Checkbox 
        label="Show area of interest"
        checkbox={overlayCheckbox}
        isLoading={false}
      /> */}

      <Checkbox 
        label="Highlight max"
        checkbox={showMaxCheckbox}
        isLoading={false}
      />

      <Checkbox 
        label="Highlight min"
        checkbox={showMinCheckbox}
        isLoading={false}
      />
      <p className="processed-date-text">{`Version: ${version}`}</p>
    </>
  )
}

export default AnalysisControls